<div class="navbar-wrapper">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/admin']" role="button" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">
        <i-bs name="house" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Go to Admin</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/management']" role="button" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Dashboard</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/management/employees"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Employee (Approval)</span>
      </a>
      <div class="collapse" routerLinkActive="show">
        <ul class="nav nav-sm flex-column">
          <li class="nav-item">
            <a [routerLink]='["/management/employees"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> E </span>
              <span class="sidenav-normal"> Approval-I (Biodata) </span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]='["/management/employees/transfer-requests"]' routerLinkActive="active"
            [queryParams]="{ financialYearId: setting?.financialYearId, phaseId: setting?.phaseId }" class="nav-link">
              <span class="sidenav-mini-icon"> T </span>
              <span class="sidenav-normal"> Approval-II (Transfer Request) </span>
            </a>
          </li>
        </ul>
      </div>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/management/allotment"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Allotment</span>
      </a>
      <div class="collapse" routerLinkActive="show">
        <ul class="nav nav-sm flex-column">
          <li class="nav-item">
            <a [routerLink]='["/management/allotment"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> L </span>
              <span class="sidenav-normal"> Allotment List </span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]='["/management/allotment/export"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> E </span>
              <span class="sidenav-normal"> Excel Export </span>
            </a>
          </li>
          <!-- <li class="nav-item">
            <a [routerLink]='["/management/allotment/process"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> P </span>
              <span class="sidenav-normal"> Allotment Process </span>
            </a>
          </li> -->
        </ul>
      </div>
    </li>

    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/management/transfer-orders"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Transfer Orders</span>
      </a>
    </li>
  </ul>
</div>